/* eslint-disable */

/**
 * An enum for normalization strategies.  The values here correspond to those defined in
 * {@link com.squareup.crypto.tokenization.NormalizationStrategy}.
 */
export enum NormalizationStrategy {
  DEFAULT = "DEFAULT",
  EMAIL = "EMAIL",
}

/**
 * Used to indicate how sensitive data is in a field. The values here correspond to the PII levels
 * defined in http://go/piisemantictypes.
 *
 * The API Log inspector reads this enum and filters values that are not NONE or BASIC_PII. If the
 * field is absent then we assume the value is NONE. For more detail, read the proposal doc:
 * https://docs.google.com/document/d/1pMLUuYI-SxGnB85SDffBr95kC3UI4S_5xdRDsZgjkIA/edit#
 */
export enum DataSensitivityLevel {
  /** NONE - Contains no sensitive data */
  NONE = "NONE",
  /** BASIC_PII - Basic PII information such as name, email, etc. */
  BASIC_PII = "BASIC_PII",
  /** PCI - Payment Card Industry (PCI) Information */
  PCI = "PCI",
  /** SECRET - Secrets that should be considered highly confidential (password, access token, etc.) */
  SECRET = "SECRET",
  /** BUSINESS_INFORMATION - Business information */
  BUSINESS_INFORMATION = "BUSINESS_INFORMATION",
  /** NPI - Non-Public Information */
  NPI = "NPI",
  /** MNPI - Material Non-Public Information */
  MNPI = "MNPI",
}
